module.exports = __webpack_public_path__ + "static/media/stats-satisfaction.d7244ac6.png";